export default {
  title: 'PROVIDER PAYMENT',
  items: {
    ProviderPaymentBonusLimit: {
      label: 'Provider Payment Bonus Limit',
      type: 'integer',
      unit: '0 - 50%'
    }
  }
}
  


// WEBPACK FOOTER //
// ./src/components/Settings/settings-config/provider-payment-bonus.js